import React from 'react';
import Header from '../../components/layout/Header';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/layout/Sidebar';
import CostingProfileComponent from '../../components/costManagement/CostingProfileComp';

const CostingProfile = ({ nav }) => {
    return (
        <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                <main className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center">
                        <div className="breadcrumb-title pe-3 text-white">Costing Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to='/'>
                                            <i className="bx bx-home-alt text-white" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Manage costing profile
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    {/*end breadcrumb*/}
                    <CostingProfileComponent />
               
                    {/*end row*/}
                </main>
            </div>
    );
};

export default CostingProfile;